export function normalizeShapePickerSearch(value: string): string {
  return value
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

export function matchesShapePickerSearch(searchQuery: string, tokens: readonly unknown[]): boolean {
  const terms = normalizeShapePickerSearch(searchQuery).split(/\s+/).filter(Boolean);
  if (terms.length === 0) return true;

  const haystack = normalizeShapePickerSearch(
    tokens
      .filter((token) => token !== null && token !== undefined)
      .map((token) => String(token))
      .join(' '),
  );

  return terms.every((term) => haystack.includes(term));
}

export function filterShapePickerItems<T>(
  items: readonly T[],
  searchQuery: string,
  getTokens: (item: T) => readonly unknown[],
): T[] {
  if (!normalizeShapePickerSearch(searchQuery)) return [...items];
  return items.filter((item) => matchesShapePickerSearch(searchQuery, getTokens(item)));
}
